var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicseaOctopus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "151 59 301 284",
    color: "text",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.33,205.2a70.09,70.09,0,0,0-31.59-38.06l-.11-.06a1.81,1.81,0,0,0-2.26,2.77,47,47,0,0,1,6.49,52.3,70.21,70.21,0,0,0-22.59-16l-.12-.05a1.81,1.81,0,0,0-2,3,47,47,0,0,1,14.26,26.69,46.84,46.84,0,0,1-52.59,6.8,75,75,0,0,0,19.88-47.87,94.92,94.92,0,0,0,10-47c-2.2-50.58-43-89.95-91-87.86s-85.19,44.85-83,95.43a94.89,94.89,0,0,0,14.06,46,74.88,74.88,0,0,0,17.67,39.49,46.79,46.79,0,0,1-52.9-7.64,47.06,47.06,0,0,1,13.06-26.4,1.81,1.81,0,0,0-2.09-2.9l-.12,0a70.49,70.49,0,0,0-20.87,15.78,47,47,0,0,1,5.11-49.79,1.81,1.81,0,0,0-2.4-2.65l-.11.07a70.37,70.37,0,0,0-20.81,97.42,70.3,70.3,0,0,0,135.24,29.07c.76-1.82,1.42-3.66,2-5.51A70.31,70.31,0,0,0,439,268,70.3,70.3,0,0,0,447.33,205.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicseaOctopus);
export default __webpack_public_path__ + "static/media/magicsea_octopus.8f454dc41dbd4252951c3f5fc89744b1.svg";
export { ForwardRef as ReactComponent };